import axios from 'axios';
const baseURL = "https://api.smartparley.de";
const allowOrigin = "https://meet.smartparley.de";
const instance = axios.create({
    baseURL: baseURL,
    headers: {
        'Access-Control-Allow-Origin': allowOrigin,
        'Accept-Language': 'de'
    }
});
const checkAuthorization = (json) => {
    if (json.message === "Unauthenticated.") {
        window.location.href = "https://www.smartparley.de";
    }
};
export const getData = (url, params) => {
    return instance({
        method: 'GET',
        url,
        params,
        withCredentials: true,
        validateStatus: (status) => {
            if (status === 404) {
                window.location.href = "https://app.smartparley.de/not-authorized";
            }
            return status >= 200 && status < 300; // Return true for 2xx status codes
        },
        transformResponse: [
            function (data) {
                let json = {};
                if (data) {
                    json = JSON.parse(data);
                    checkAuthorization(json);
                }
                return json;
            }
        ]
    });
};
export const postData = (url, data, params) => {
    return instance({
        method: 'POST',
        url,
        params,
        data,
        withCredentials: true,
        validateStatus: (status) => {
            return status >= 200 && status < 300; // Return true for 2xx status codes
        },
        transformResponse: [
            function (data) {
                let json = {};
                if (data) {
                    json = JSON.parse(data);
                    checkAuthorization(json);
                }
                return json;
            }
        ]
    });
};
export const putData = (url, data, params) => {
    return instance({
        method: 'PUT',
        url,
        params,
        data,
        withCredentials: true,
        validateStatus: (status) => {
            return status >= 200 && status < 300; // Return true for 2xx status codes
        },
        transformResponse: [
            function (data) {
                let json = {};
                if (data) {
                    json = JSON.parse(data);
                    checkAuthorization(json);
                }
                return json;
            }
        ]
    });
};
export const deleteData = (url, data, params) => {
    return instance({
        method: 'DELETE',
        url,
        params,
        data,
        withCredentials: true,
        validateStatus: (status) => {
            return status >= 200 && status < 300; // Return true for 2xx status codes
        },
        transformResponse: [
            function (data) {
                let json = {};
                if (data) {
                    json = JSON.parse(data);
                    checkAuthorization(json);
                }
                return json;
            }
        ]
    });
};
